import React, { ReactElement } from "react";
import HubShopDetails from "../../../components/Hubs/Shops/details";
import Layout from "../../../components/layout";
import MerchantShopDetails from "../../../components/Merchant/Shops/details";

const MerchantShopDetailsPage = (): ReactElement => {
  return (
    <Layout>
      <MerchantShopDetails />
    </Layout>
  );
};

export default MerchantShopDetailsPage;
